import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LucideAngularModule, AlertTriangle, Loader2 } from 'lucide-angular';

@Component({
  selector: 'app-confirmacao-sim-nao',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  templateUrl: './confirmacao-sim-nao.component.html'
})
export class ConfirmacaoSimNaoComponent {
  readonly alertTriangleIcon = AlertTriangle;
  readonly loader2Icon = Loader2;

  @Input() aberta = false;
  @Input() titulo = '';
  @Input() carregando = false;
  @Input() labelConfirmar = 'Sim';
  @Input() labelCancelar = 'Não';

  @Output() confirmar = new EventEmitter<void>();
  @Output() cancelar = new EventEmitter<void>();
}
